/* eslint-disable */
<template>
  <main-banner :banners="banners"></main-banner>
  <section class="pedidos-section">
    <div class="container">
      <div class="section-title">
        <h4>Servicios</h4>
      </div>
      <div class="row">
        <div class="col-md-4 index-option" v-if="this.country === 'argentina' && this.admin_cuota">
          <div class="box-pedido">
            <router-link :to="route + 'zona-listado'">
              <img :src="require('@/assets/img/pedidos1.png')" alt="zonas">
              <h3>Zonas</h3>
            </router-link>
          </div>
        </div>
        <div class="col-md-4 index-option">
          <div class="box-pedido">
            <router-link :to="route + 'cuota-listado'">
              <img :src="require('@/assets/img/pedidos1.png')" alt="cuotas">
              <h3>Cuotas</h3>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {route} from "../../enviroment.js"
import MainBanner from "../layouts/MainBanner.vue"
import axios from 'axios'

export default {
  name: "HomePage",
  components: {
    MainBanner
  },
  data() {
    return {
      route: route,
      banners: [],
      country: '',
      admin_cuota: false,
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      const profile = sessionStorage.getItem('mccain_cuotas_user');
      if (profile) {
        const data = JSON.parse(profile);
        this.name = data.firstname + ' ' + data.lastname;
        this.country = data?.address?.countryName.toString().toLowerCase();
        this.admin_cuota = data?.admin_cuota === true;
      }
    },
    getBanners() {
      axios.get('/banners')
          .then((response) => {
            this.banners = response.data.data.banners
          })
          .catch((error) => {
            if (error.code == "ERR_BAD_REQUEST") {
              location.href = route + "login";
            }
          })
    }
  }
}
</script>